import { Component, input } from '@angular/core';
import { BooleanPipe } from '@core/pipes/boolean.pipe';
import { DecimalPipe, PercentPipe } from '@angular/common';
import { PengeinstitutIndstilling } from '../../pi-indstilling/pengeinstitutindstilling.model';
import { ScrollPanel } from 'primeng/scrollpanel';
import { TranslatePipe } from '@core/pipes/translate.pipe';

@Component({
  selector: 'app-pi-detail-indbetalingsaftale',
  imports: [BooleanPipe, DecimalPipe, ScrollPanel, TranslatePipe, PercentPipe],
  templateUrl: './pi-detail-indbetalingsaftale.component.html',
  styleUrl: './pi-detail-indbetalingsaftale.component.css',
})
export class PiDetailIndbetalingsaftaleComponent {
  indstillinger = input.required<PengeinstitutIndstilling>();
}
